var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['body-html-'+_vm.device]},[_c('HeaderVue'),_c('router-view',{staticClass:"main"}),_c('ServiceVue'),_c('FooterVue')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }